// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 20H4V17H15V12H4V9H19V4L4 4V2L2 2L2 22H22V20Z"}}]};

const ChartColumnFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-column-filled',
    ref,
    icon: element,
  },
));

ChartColumnFilledIcon.displayName = 'ChartColumnFilledIcon';

export default ChartColumnFilledIcon;
